import { render, staticRenderFns } from "./KeyValueRow.vue?vue&type=template&id=3fe09677&scoped=true&"
import script from "./KeyValueRow.vue?vue&type=script&lang=js&"
export * from "./KeyValueRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe09677",
  null
  
)

export default component.exports